import { useCallback, useEffect, useState } from "react";
import api from "../services/api";

/** Wraps GET /care-manager/onboarding/status with loading/error/data state. */
export function useCareManagerOnboardingStatus({ enabled = true } = {}) {
  const [onboarding, setOnboarding] = useState(null);
  const [loading, setLoading] = useState(Boolean(enabled));
  const [error, setError] = useState("");

  const refetch = useCallback(async () => {
    if (!enabled) return null;
    setLoading(true);
    setError("");
    try {
      const res = await api.getCareManagerOnboardingStatus();
      const row = res?.onboarding || res?.data?.onboarding || res;
      setOnboarding(row);
      return row;
    } catch (err) {
      setError(err.message || "Unable to load onboarding status.");
      return null;
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { onboarding, loading, error, refetch };
}

export default useCareManagerOnboardingStatus;
